import ActiveIcon from 'components/Icons/ActiveIcon';
import ActiveWhiteIcon from 'components/Icons/ActiveWhiteIcon';
import InactiveIcon from 'components/Icons/InactiveIcon';
import { StatusFile } from 'models/statusFile';
import React, { FC, useMemo } from 'react';

type StatusPillProps = {
  selected?: boolean;
  status: string;
  summary?: boolean;
};

const StatusPill: FC<StatusPillProps> = ({ status = '', selected, summary }) => {
  const statusFile = status;

  const includeStatus = status.includes(statusFile);

  const isProcessedStatus = statusFile === StatusFile.PROCESSED;

  const isStatusFileActive = statusFile === 'Active';

  const isStatusFileInactive = statusFile === 'Inactive';

  const isStatusFileProcessed = statusFile === StatusFile.PROCESSED;

  const isActiveOrInactive = isStatusFileActive || isStatusFileInactive;

  const statusBeneficiaryClass = useMemo(() => {
    if (isStatusFileProcessed) {
      let selectedClass = '';

      if (selected) {
        selectedClass = summary ? '-selected-summary' : '-selected';
      }

      return `status active-beneficiary${selectedClass}`;
    }

    return `status inactive-beneficiary${selected ? '-selected' : ''}`;
  }, [isStatusFileProcessed, selected]);

  const renderIcon = useMemo(() => {
    const Active = selected && !summary ? ActiveWhiteIcon : ActiveIcon;

    if (isProcessedStatus) return <Active />;

    return <InactiveIcon />;
  }, [isProcessedStatus, selected]);

  if (includeStatus && !isActiveOrInactive)
    return (
      <div className={statusBeneficiaryClass}>
        {renderIcon}
        <strong>{isProcessedStatus ? 'Concluído' : 'Erro'}</strong>
      </div>
    );

  if (isActiveOrInactive)
    return (
      <div className={isStatusFileActive ? 'status active-beneficiary' : 'status inactive-beneficiary'}>
        {isStatusFileActive ? <ActiveIcon /> : <InactiveIcon />}
        <strong>{isStatusFileActive ? 'Habilitado' : 'Desabilitado'}</strong>
      </div>
    );
  return null;
};

export default StatusPill;
